import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { machineProfile } from "../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext.jsx";
import {
  dateToToday,
  formatDateOnly,
  generateLocationToArray,
  printLocation,
} from "../../utils/helper.jsx";
import { useDashboardContext } from "../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import { MachineProfile } from "../../api/machine_profile.js";
import ConfirmationDlg from "../../components/ConfirmationDlg/index.jsx";
import SideBarLocation from "../../components/SideBarLocation";
import ModalNavigation from "./modal/ModalNavigation";

function MachineHierarchy() {
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState({ company: true });
  const { config } = useAuth();
  const { machineTypes } = useDashboardContext();
  const [deleteRow, setDeleteRow] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const navigate = useNavigate();

  async function getMachine() {
    try {
      setLoading(true);
      const queryParam = {
        ...query,
      };
      const res = await machineProfile.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data) {
          data.forEach((d) => {
            const locationNameArr = [];
            generateLocationToArray(d.location, locationNameArr);
            d.location_arr = locationNameArr.reverse();
          });
          setDatas(data);
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }

  function generateLocationWording() {
    let result = [];
    if (config && config?.location_wording) {
      const words = config?.location_wording.split(",");
      words.forEach((ln, index) => {
        result.push(ln);
      });
    }

    return result;
  }

  function hideConfirmationDialog() {
    setDeleteRow(null);
  }

  function countOnlineOffline(machine) {
    let online = 0;
    let offline = 0;
    machine.machine_elements.forEach((cm) => {
      if (
        cm.deployments[0]?.sensor?.sensor_uptime[0]?.on_off_status === "true"
      ) {
        online++;
      } else {
        offline++;
      }
    });
    return { online, offline };
  }

  const columns = [
    // ...generateLocationWording().map((w, i) => ({
    //   name: w,
    //   selector: (row) => printLocation(row.location_arr[i]),
    // })),
    {
      name: "Machine Name",
      selector: (row) => row.machine_name,
    },
    {
      name: "Machine Type",
      selector: (row) => row.machine_type.name,
    },
    {
      name: "Sensor Online Status",
      minWidth: "200px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => (
        <div>
          {countOnlineOffline(row).offline === 0 ? (
            <span
              style={{
                padding: "1px 15px 1px 15px",
                color: "#040930",
                background: "#71c56b",
              }}
            >
              All Online
            </span>
          ) : (
            <>
              <span
                style={{
                  padding: "1px 15px 1px 15px",
                  color: "#040930",
                  background: "#71c56b",
                }}
              >
                {countOnlineOffline(row).online} Online
              </span>{" "}
              -
              <span
                style={{
                  padding: "1px 15px 1px 15px",
                  color: "#040930",
                  background: "#ff8c87",
                }}
              >
                {countOnlineOffline(row).offline} Offline
              </span>
            </>
          )}
        </div>
      ),
    },
  ];

  useEffect(() => {
    getMachine();
    // eslint-disable-next-line
  }, [query]);

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <div id="datatable" className="mb-5">
            <div className="row">
              <div className="col-md-12">
                <SideBarLocation />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MachineHierarchy;
